
  var _styles = {
  "three-card-container-three": {
    "fontFamily": "PingFang SC",
    "width": "3.01333rem",
    "height": "4.70667rem",
    "marginTop": "0.16rem",
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "three-card-image-view": {
    "width": "100%",
    "height": "2.26667rem",
    "overflow": "hidden",
    "borderRadius": "0.24rem 0.24rem 0 0"
  },
  "three-card-custom-tag": {
    "width": "1.38667rem",
    "height": "0.42667rem"
  },
  "three-card-custom-tag-bg": {
    "width": "1.38667rem",
    "height": "0.42667rem",
    "overflow": "hidden",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "borderRadius": "0.24rem 0 0.24rem 0"
  },
  "three-card-custom-tag-view": {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "paddingTop": "0.02667rem",
    "paddingRight": 0,
    "paddingBottom": "0.02667rem",
    "paddingLeft": 0
  },
  "three-card-custom-tag-text": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.29333rem",
    "color": "rgb(255,255,255)"
  },
  "three-card-image": {
    "width": "100%",
    "height": "100%",
    "borderRadius": "0.24rem 0.24rem 0 0",
    "OObjectFit": "cover",
    "objectFit": "cover"
  },
  "three-card-image-tag": {
    "position": "absolute",
    "width": "0.96rem",
    "height": "0.48rem",
    "top": 0,
    "left": "-0.05333rem",
    "zIndex": 10
  },
  "three-departures-container": {
    "position": "absolute",
    "left": "0.8rem",
    "top": 0,
    "zIndex": 9
  },
  "three-departures-background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "0.42667rem",
    "zIndex": 11
  },
  "three-departures-text": {
    "height": "0.42667rem",
    "fontSize": "0.25333rem",
    "color": "rgb(228,225,225)",
    "zIndex": 12,
    "paddingLeft": "0.22667rem",
    "paddingRight": "0.13333rem",
    "lineHeight": "0.42667rem"
  },
  "three-card-content-right": {
    "flex": 1,
    "width": "100%",
    "height": "2.34667rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "column"
  },
  "three-card-top-field": {
    "width": "100%",
    "display": "flex"
  },
  "three-card-tag-field": {
    "marginTop": "0.04rem",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "three-card-day-tag": {
    "borderTopLeftRadius": "0.08rem",
    "borderTopRightRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "borderBottomRightRadius": "0.08rem",
    "overflow": "hidden",
    "width": "0.42667rem",
    "maxWidth": "0.42667rem",
    "height": "0.42667rem",
    "marginRight": "0.06667rem",
    "marginBottom": "-0.06667rem"
  },
  "three-card-day-tag-text": {
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "backgroundColor": "rgb(255,209,0)"
  },
  "three-card-deal-name": {
    "position": "relative",
    "fontSize": "0.37333rem",
    "width": "2.74667rem",
    "textAlign": "left",
    "verticalAlign": "bottom"
  },
  "three-card-day-h5-tag-view": {
    "position": "absolute",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "0.37333rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "borderRadius": "0.08rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem"
  },
  "three-card-day-h5-tag-text": {
    "color": "rgb(34,0,0)",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "three-card-deal-name-text": {
    "color": "rgb(34,34,33)",
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "lineHeight": "0.4rem"
  },
  "three-card-tag": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "minHeight": "0.37333rem",
    "paddingTop": "0.16rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.16rem",
    "overflow": "hidden"
  },
  "three-card-product-tag-group": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)",
    "marginRight": "0.05333rem",
    "whiteSpace": "nowrap",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-card-product-tag-text-group": {
    "color": "rgb(85,85,85)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.05333rem",
    "marginBottom": 0,
    "marginLeft": "0.05333rem"
  },
  "three-card-product-tag-price": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,226,188)",
    "marginRight": "0.05333rem",
    "whiteSpace": "nowrap",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-card-product-tag-text-price": {
    "color": "rgb(255,75,16)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.05333rem",
    "marginBottom": 0,
    "marginLeft": "0.05333rem"
  },
  "three-card-people-tag": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(142,60,18,0.2980392157)",
    "marginRight": "0.05333rem",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-card-people-tag-text": {
    "color": "rgb(85,85,85)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.05333rem",
    "marginBottom": 0,
    "marginLeft": "0.05333rem"
  },
  "three-card-product-tag-free": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-card-product-tag-text-free": {
    "color": "rgb(85,85,85)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "three-card-bottom-field": {
    "width": "100%",
    "height": "0.85333rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem",
    "marginTop": "-0.10667rem"
  },
  "three-card-bottom-left-field": {
    "flex": 1,
    "height": "0.85333rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "alignItems": "flex-start",
    "paddingTop": 0
  },
  "three-card-price-now": {
    "height": "0.85333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "color": "rgb(255,75,16)"
  },
  "three-card-price-icon": {
    "color": "rgb(255,75,16)",
    "fontWeight": "700",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "verticalAlign": "bottom",
    "marginTop": "0.16rem",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "three-card-price-price": {
    "fontWeight": "700",
    "lineHeight": "0.85333rem",
    "marginLeft": 0,
    "marginRight": "0.09333rem",
    "color": "rgb(255,75,16)",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "three-card-price-start": {
    "color": "rgb(102,102,102)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem",
    "fontFamily": "PingFang SC",
    "marginLeft": "-0.08rem",
    "marginTop": "0.21333rem"
  },
  "three-card-price-origin": {
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#666",
    "textDecorationColor": "#666",
    "color": "rgb(102,102,102)",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "marginBottom": "0.02667rem"
  },
  "three-card-discount-width-field": {
    "height": "0.37333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "three-card-discount-left-field": {
    "alignSelf": "flex-start",
    "borderTopLeftRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "lineHeight": "0.37333rem",
    "height": "100%"
  },
  "three-card-discount-img": {
    "height": "0.37333rem",
    "width": "0.37333rem"
  },
  "three-card-discount-width-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "paddingBottom": "0.02rem",
    "marginRight": "0.02667rem"
  },
  "three-card-discount-right-field": {
    "height": "0.37333rem",
    "display": "flex",
    "alignSelf": "flex-start",
    "flexDirection": "row",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "borderRadius": "0 0.08rem 0.08rem 0"
  },
  "three-card-curve-img": {
    "height": "0.37333rem",
    "width": "0.10667rem",
    "marginLeft": "-0.02667rem"
  },
  "three-card-reduce-text": {
    "lineHeight": "0.37333rem",
    "fontFamily": "MTNewDigitalDisplay-Regular",
    "color": "rgb(255,75,16)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginRight": "0.08rem"
  },
  "three-card-discount-field": {
    "height": "0.37333rem",
    "marginTop": "-0.04rem",
    "display": "flex",
    "flexDirection": "row",
    "alignSelf": "flex-start",
    "borderRadius": "0.08rem"
  },
  "three-card-discount-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginRight": "0.08rem",
    "marginTop": "0.01333rem"
  },
  "three-card-bottom-right-field-container": {
    "width": "1.12rem",
    "height": "0.85333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-card-bottom-right-field": {
    "width": "1.12rem",
    "height": "0.64rem",
    "borderRadius": "0.4rem",
    "overflow": "hidden"
  },
  "three-card-bottom-right-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "600",
    "fontSize": "0.32rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  